module.exports = __webpack_public_path__ + "static/media/home-hero--foreground-solid.d994e5fb.png";